import api, { handleResponse, handleError } from './api';

const stripeService = {
  /**
   * Start Stripe Connect onboarding for hosts
   * Returns a URL to redirect the user to Stripe's onboarding flow
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  /**
   * @param {string} [redirectTo] — 'wallet' | 'settings' | 'host'. Controls where
   *   Stripe routes the user back to after onboarding. Default 'settings'.
   */
  async startOnboarding(redirectTo) {
    try {
      const url = redirectTo ? `/stripe/connect/onboard?redirectTo=${encodeURIComponent(redirectTo)}` : '/stripe/connect/onboard';
      const response = await api.post(url);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Get the current Stripe Connect status for the user
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async getConnectStatus() {
    try {
      const response = await api.get('/stripe/connect/status');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Create a SetupIntent for saving a payment method
   * Used for guests to save their payment method for future charges
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async createSetupIntent() {
    try {
      const response = await api.post('/stripe/setup-intent');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Get payment recovery information for a failed application payment
   * @param {string} applicationId - Application ID
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async getPaymentRecovery(applicationId) {
    try {
      const response = await api.get(`/stripe/payment-recovery/${applicationId}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getVerificationStatus() {
    try {
      const response = await api.get('/stripe/connect/verification-status');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async startOnboard() {
    try {
      const response = await api.post('/stripe/connect/onboard');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getDashboardLink() {
    try {
      const response = await api.get('/stripe/connect/dashboard-link');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default stripeService;
